import './content-item-columns-styles.css';

// The purpose of this "component" is solely to pull in column styling for any component that needs it

export const ColumnStylesReference = () => <></>;
